import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import {
	getShareProfileBodyContentByOrgId,
	postSentInvitations,
} from '../../../api/VisitsAPI';

export function ShareProfile({ orgID }) {
	const [open, setOpen] = useState(false);
	const [isSubmitting, setIsSubmitting] = React.useState(false);
	const [isError, setIsError] = React.useState(false);
	const [isSubmitSuccessful, setIsSubmitSuccessful] = React.useState(false);

	function refreshPage() {
		window.location.reload(false);
	}

	function validateEmail(email) {
		var re = /\S+@\S+\.\S+/;
		return re.test(email);
	}
	const ShareProfileModal = () => {
		const [fullName, setFullName] = useState();
		const [email, setEmail] = useState();
		const [body, setBody] = useState();

		const fetchShareProfileContent = async () => {
			const { data } = await getShareProfileBodyContentByOrgId(orgID);
			const { shareProfileBodyContent } = data;
			setBody(shareProfileBodyContent);
		};

		const postInvitation = async () => {
			if (!validateEmail(email)) {
				alert('Please Enter Valid Email');
				return;
			}
			const payload = {
				full_name: fullName,
				email,
				body,
				organization_id: orgID,
			};

			try {
				await postSentInvitations(orgID, payload);
				setIsSubmitSuccessful(true);
			} catch (error) {
				setIsError(true);
				setIsSubmitSuccessful(false);
			}
		};

		useEffect(() => {
			fetchShareProfileContent();

			if (isSubmitSuccessful) {
				setTimeout(() => {
					setIsSubmitSuccessful(false);
					setOpen(false);
					refreshPage();
				}, 2000);
			}
		}, []);

		const handleSubmitShare = async () => {
			setIsSubmitting(true);
			await postInvitation();
			setIsSubmitting(false);
		};

		if (isSubmitting) {
			return <div>Sending Email...</div>;
		}

		if (isSubmitSuccessful) {
			return <div>Invitation Sent!</div>;
		}

		if (isError) {
			return (
				<div>
					<h5>There was an issue sending the Email</h5>
					<p>Please contact support.</p>
				</div>
			);
		}

		return (
			<div>
				<h4>
					<b>Are you ready?</b>
				</h4>
				<h5>
					Be sure to upload your sponsorship materials and include
					your campaign details - then click send to connect!
				</h5>

				<div>
					<div>
						<label className="string optional">Full name</label>
						<input
							onChange={(e) => setFullName(e.target.value)}
							type="text"
							placeholder="Joe Smith"
						/>
					</div>
					<div>
						<label className="string optional">Email</label>
						<input
							onChange={(e) => setEmail(e.target.value)}
							type="text"
							placeholder="email@example.com"
						/>
					</div>
					<textarea
						value={body}
						onChange={(e) => setBody(e.target.value)}
						className="organization-modal-body-container"
						name="share_profile[body]"
						id="share_profile_body"
						data-form-type="other"
					></textarea>
					<div className="text-right">
						<button
							onClick={handleSubmitShare}
							name="button"
							type="submit"
							className="primary-button"
							data-dashlane-rid="7abe2c47d0c31362"
							data-dashlane-label="true"
							data-form-type="action"
						>
							<p>Send</p>
						</button>
					</div>
				</div>
			</div>
		);
	};

	return (
		<div className="visits">
			<h5>Share profiles</h5>
			<div
				onClick={() => setOpen(!open)}
				className="primary-button open-logo-upload open-modal"
				data-modal="share-profile-modal"
			>
				<p>Send share profile</p>
			</div>
			{open && (
				<Modal
					Content={ShareProfileModal}
					modalState={open}
					turnOffModal={() => setOpen('')}
				/>
			)}
		</div>
	);
}
